import {financeAPI} from "../../axios";

export const actions = {
    createPayment(context, data){
        return financeAPI.post('RFP/Payment/Create', data);
    },
    getSinglePayment(context, id){
        return financeAPI.get(`RFP/Payment/${id}`);
    },
    updatePayment(context, data){
        return financeAPI.put(`RFP/Payment/${data.id}`, data);
    },
    deletePayment(context, id){
        return financeAPI.delete(`RFP/Payment/${id}`);
    },
    postPayment(context, id){
        return financeAPI.put(`RFP/Payment/Post/${id}`);
    },
    returnPayment(context, id){
        return financeAPI.put(`RFP/Payment/Return/${id}`);
    },
    getDUPending(context, data){
        return financeAPI.get(`RFP/Payment/Draft/${data.deliveryUnitId}/${data.cycle}`);
    },
    getDUPosted(context, data){
        return financeAPI.get(`RFP/Payment/Posted/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },
    getAllAvailable(context, cycle){
        return financeAPI.get(`RFP/Payment/Available?cycle=${cycle}`);
    },
    getAllAvailableResource(context, data){
        return financeAPI.get(`RFP/Payment/Available/Resource/${data.cycle}/${data.deliveryUnitId}`);
    },
    getAllPaymentsByExpenditure(context, {id, cycle}){
        return financeAPI.get(`RFP/Payment/All/${id}/${cycle}`)
    }
}